/**
 * Simple event system for wallet balance updates.
 * 
 * Used to notify the header when balance changes from any component.
 */

type WalletEventCallback = (newBalance?: number) => void

class WalletEventEmitter {
  private listeners: Set<WalletEventCallback> = new Set()

  /**
   * Subscribe to balance update events
   */
  subscribe(callback: WalletEventCallback): () => void {
    this.listeners.add(callback)
    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback)
    }
  }

  /**
   * Emit a balance update event.
   * @param newBalance - Optional new balance value. If not provided, listeners should refetch.
   */
  emit(newBalance?: number): void {
    this.listeners.forEach(callback => callback(newBalance))
  }
}

// Singleton instance
export const walletEvents = new WalletEventEmitter()

/**
 * Helper function to notify that wallet balance has changed.
 * Call this after any operation that modifies the user's credit balance.
 */
export function notifyWalletUpdate(newBalance?: number): void {
  walletEvents.emit(newBalance)
}






